import React, { useEffect } from "react";
import { useStore } from "../../store/store";
import { calculatePanelHeight } from "../../util/formulas/calculatePanelHeight";
import { SelectChangeEvent } from "@mui/material";
import fractionToInt from "../../util/fractionToInt";
// import { calculateAlumSideliteHeight } from "../../util/formulas/calculateAlumSideliteHeight";

interface UpdateObj {
  height: string;
  handleHeight?: string;
}

function useHeightSelector(showHandleHeight: (show: boolean) => void) {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorType = useStore((state) => state.quote.doorType);

  const direction = useStore((state) => state.quote.swingDirection);
  // const sideLite = useStore((state) => state.quote.sideLite);

  const handleHeight = useStore((state) => state.quote.handleHeight);

  const material = useStore((state) => state.quote.material);
  const height = useStore((state) => state.quote.height);
  const heightFraction = useStore((state) => state.quote.heightFraction);

  const handleErrMsgChange = useStore((state) => state.handleError);
  const errors = useStore((state) => state.errors);

  const screenType = useStore((state) => state.quote.screenType);
  const addScreen = useStore((state) => state.quote.addScreen);
  const sillStyle = useStore((state) => state.quote.sillStyle);

  const stilesAndRailsCategory = useStore((state) => state.quote.stileCategory);

  const overall = fractionToInt(height, heightFraction || "");

  const alumThickFrame = useStore((state) => state.quote.alumThickFrame);

  const isAlum = material === "All Aluminum";

  const isPico = stilesAndRailsCategory?.includes("Pico") ? true : false;

  const exactConfig = useStore((state) => state.quote.exactConfig);

  let swingPanelHeight = calculatePanelHeight({
    exactConfig: exactConfig,
    doorType: "Swing",
    sillStyle: sillStyle || "",
    netHeight: overall,
    screenType: addScreen && screenType ? screenType : "",
    material,
    isPico,
    swingDirection: direction,
    alumThickFrame: alumThickFrame || false
  });

  // const alumSideliteHeight =
  //   isAlum && sideLite && sideLite !== "none"
  //     ? calculateAlumSideliteHeight({
  //         netHeight: overall,
  //         screenType: addScreen && screenType ? screenType : "",
  //         swingDirection: direction || "",
  //         alumThickFrame: alumThickFrame || false
  //       })
  //     : 0;

  useEffect(() => {
    if (!height) return;

    const withCentor =
      addScreen && screenType?.includes("Centor") ? true : false;

    const range =
      // isAlum && doorType?.includes("Window")
      //   ? { min: 12, max: 60, minString: '12"', maxString: '60"' }
      doorType === "Bi-fold Window"
        ? { min: 26, max: 72, minString: '26"', maxString: '72"' }
        : doorType === "Fixed Panel"
        ? { min: 26, max: 122.5, minString: '26"', maxString: '122 1/2"' }
        : doorType === "Pivot"
        ? { min: 72, max: 121.875, minString: '72"', maxString: '121 7/8"' }
        : { min: 72, max: 122.5, minString: '72"', maxString: '122 1/2"' };

    if (overall <= range.max && overall >= range.min) {
      handleErrMsgChange("heightErr", "");
    } else if (overall < range.min) {
      handleErrMsgChange("heightErr", `${errMessageLow} ${range.minString}`);
    } else if (overall > range.max) {
      handleErrMsgChange("heightErr", `${errMessageHigh} ${range.maxString}`);
    }

    const resetObj = {
      addScreen: "",
      screenLayout: "",
      screenPocket: "",
      screenType: "",
    };

    // if (isAlum) {
    //   addToQuote({ alumThickFrame: overall >= 102 });
    // }

    let reset = false;

    if (
      doorType === "Bi-fold Window" &&
      stilesAndRailsCategory === "Pico" &&
      overall < 38
    ) {
      resetObj["stileCategory"] = "";
      resetObj["stilesAndRails"] = "";
      reset = true;
    }

    if (withCentor) {
      let centorHeight = 0;

      if (doorType === "Slider") {
        centorHeight = sillStyle?.includes("Steel")
          ? overall + 1.1792
          : overall - 0.5625;
      } else {
        centorHeight = sillStyle?.includes("Ultra")
          ? overall + 1.1875
          : overall - 0.5625;
      }

      if (
        doorType?.includes("Window") &&
        centorHeight >= 25 &&
        centorHeight < 32.125
      ) {
        reset = true;
      }

      if (
        (addScreen?.includes("Combo") || addScreen?.includes("Shade")) &&
        centorHeight > 114
      ) {
        reset = true;
      }
    } else {
      if (doorType?.includes("Window") && overall >= 26 && overall < 32) {
        reset = true;
      }
    }

    if (reset) {
      addToQuote(resetObj);
    }
  }, [height, heightFraction, doorType]);

  const handleFractionChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    addToQuote({ heightFraction: value });
  };

  const errMessageHigh = "Height can not exceed";
  const errMessageLow = "Height must be at least";

  const handleHeightChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    let update: UpdateObj = { height: value };

    const show =
      doorType === "Pivot" && parseInt(value) >= 96
        ? true
        : parseInt(value) >= 108
        ? true
        : false;

    showHandleHeight(show);

    if (!show && handleHeight === '42"') {
      update["handleHeight"] = "";
    }

    addToQuote(update);
  };

  return {
    handleHeightChange,
    handleFractionChange,
    swingPanelHeight,
    heightErr: errors.heightErr,
    doorType,
    height,
    heightFraction,
    // alumSideliteHeight,
    isAlum
  };
}

export default useHeightSelector;
